import { IonIcon } from '@ionic/react';
import { alertCircleOutline } from 'ionicons/icons';

export const ReleaseClauseBadge = () => (
  <span
    className="inline-flex items-center gap-1 rounded-full bg-red-100 px-2 py-0.5 text-xs font-medium text-red-700"
    data-testid="release-clause-badge"
  >
    <IonIcon icon={alertCircleOutline} className="text-xs" />
    Cláusula
  </span>
);